import { format } from 'date-fns';

export const mapDateSearchParams = (dateInterval: string) => {
  const splittedDate = dateInterval.split(',');
  return {
    dateFrom: splittedDate?.[0] ? format(new Date(splittedDate[0]), 'yyyy-MM-dd') : '',
    dateTo: splittedDate?.[1] ? format(new Date(splittedDate[1]), 'yyyy-MM-dd') : '',
  };
};
